import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=8857c0ae&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8857c0ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8857c0ae')) {
      api.createRecord('8857c0ae', component.options)
    } else {
      api.reload('8857c0ae', component.options)
    }
    module.hot.accept("./Admin.vue?vue&type=template&id=8857c0ae&scoped=true&", function () {
      api.rerender('8857c0ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Layout/Admin.vue"
export default component.exports